import { DateTime } from 'luxon';

export const usePageSeoMeta = async ({
  keepLocale = false,
  withTimetableHandling = false,
} = {}) => {
  // const { path } = useRoute();
  // useRoute() here returns wrong route on spa (previous route)
  // https://github.com/nuxt/nuxt/issues/21340
  // https://github.com/nuxt/nuxt/issues/28804
  const route = useRouter().currentRoute.value;

  const cmsStore = useCmsStore();
  const searchStore = useSearchStore();

  const formattedRoutePath = computed(() => {
    let path = route.path;
    return path.endsWith('/') ? path.slice(0, -1) : path;
  });

  function fetchPageData() {
    return cmsStore.fetchPage({
      path: formattedRoutePath.value,
      withLocalePrefix: keepLocale,
    });
  }

  async function fetchSeoPageData() {
    const data = await cmsStore.fetchPage({
      path: formattedRoutePath.value,
      withLocalePrefix: keepLocale,
    });

    const timetableSection = data?.sections?.find(
      (section) => section.type === 'timetable',
    );

    if (timetableSection) {
      let searchFilter = undefined;

      const departureId = timetableSection?.data?.departureLocationId;
      const arrivalId = timetableSection?.data?.arrivalLocationId;

      if (!departureId || !arrivalId) {
        timetableSection.data.hide = true;
        return data;
      }

      await searchStore
        .fetchLocations({
          filter: {
            id: `${departureId},${arrivalId}`,
          },
        })
        .then((cities) => {
          if (cities?.length !== 2) return;

          const { departureStation, arrivalStation } = cities.reduce(
            (acc, city) => {
              if (city.id === departureId) acc.departureStation = city;
              if (city.id === arrivalId) acc.arrivalStation = city;
              return acc;
            },
            { departureStation: null, arrivalStation: null },
          );

          searchFilter = {
            departureStation,
            arrivalStation,
            departureDate: DateTime.now()
              .plus({ days: 7 })
              .toFormat('yyyy-MM-dd'),
          };
        });

      if (!searchFilter) {
        timetableSection.data.hide = true;
        return data;
      }

      await searchStore
        .fetchSeoRoutes({
          filter: {
            departureLocationId: departureId,
            arrivalLocationId: arrivalId,
            departsDate: searchFilter.departureDate,
            disableLog: 1,
          },
          limit: 10,
        })
        .then((data) => {
          if (data.length) {
            timetableSection.data.routes = data;
            timetableSection.data.filter = searchFilter;
          } else timetableSection.data.hide = true;
        });
    }

    return data;
  }

  // Request
  const { data: pageData, error: pageError } = await useAsyncData(
    formattedRoutePath.value,
    withTimetableHandling ? fetchSeoPageData : fetchPageData,
    { default: () => ({}) },
  );

  return { pageData, pageError };
};
